import { KeyValuePair } from '../models/KeyValuePair';

export class ValueTypes {
    static average: KeyValuePair<string, string> = { key: 'average', value: 'Average' };
    static interpolated: KeyValuePair<string, string> = { key: 'interpolated', value: 'Interpolated' };
    static standardDeviation: KeyValuePair<string, string> = { key: 'standardDeviation', value: 'Standard deviation' };
    static minimum: KeyValuePair<string, string> = { key: 'minimum', value: 'Minimum' };
    static maximum: KeyValuePair<string, string> = { key: 'maximum', value: 'Maximum' };
    static gradient: KeyValuePair<string, string> = { key: 'gradient', value: 'Gradient' };
    static numberOfValues: KeyValuePair<string, string> = { key: 'numberOfValues', value: 'Number of values' };
    static percentageOfGoodValues: KeyValuePair<string, string> = { key: 'percentageOfGoodValues', value: '% of good values' };
    static status: KeyValuePair<string, string> = { key: 'status', value: 'Status' };
    static value: KeyValuePair<string, string> = { key: 'value', value: 'Value' };
    static validatedvalue: KeyValuePair<string, string> = { key: 'validatedvalue', value: 'Validated value' };
    static manualvalue: KeyValuePair<string, string> = { key: 'manualvalue', value: 'Manual value' };
    static selection: KeyValuePair<string, string> = { key: 'selection', value: 'Selection' };
    static reconciledValue: KeyValuePair<string, string> = { key: 'reconciled-value', value: 'Reconciled' };
    static reconciledPenalty: KeyValuePair<string, string> = { key: 'reconciled-penalty', value: 'Penalty' };
    static reconciledUncertainty: KeyValuePair<string, string> = { key: 'reconciled-uncertainty', value: 'Uncertainty' };
    static reconciledToreconcilevalue: KeyValuePair<string, string> = { key: 'reconciled-toreconcilevalue', value: 'ToReconcileValue' };
    static reconciledConstraint: KeyValuePair<string, string> = { key: 'reconciled-constraint-value', value: 'Constraint' };
    static reconciledTarget: KeyValuePair<string, string> = { key: 'reconciled-constraint-target', value: 'Target' };
    static sourceValue: KeyValuePair<string, string> = { key: 'sourcevalue', value: 'Value' };
    static targetValue: KeyValuePair<string, string> = { key: 'targetvalue', value: 'Target' };
    static deviation: KeyValuePair<string, string> = { key: 'deviation', value: 'Deviation' };
    static relativeDeviation: KeyValuePair<string, string> = { key: 'relativeDeviation', value: 'Relative deviation' };
    static raw: KeyValuePair<string, string> = { key: 'raw', value: 'Raw' };
    static comment: KeyValuePair<string, string> = { key: 'comment', value: 'User comment' };

    public static allValueTypes: KeyValuePair<string, string>[] = [
        ValueTypes.average,
        ValueTypes.interpolated,
        ValueTypes.standardDeviation,
        ValueTypes.minimum,
        ValueTypes.maximum,
        ValueTypes.gradient,
        ValueTypes.numberOfValues,
        ValueTypes.percentageOfGoodValues,
        ValueTypes.status,
        ValueTypes.value,
        ValueTypes.validatedvalue,
        ValueTypes.manualvalue,
        ValueTypes.selection,
        ValueTypes.reconciledValue,
        ValueTypes.reconciledPenalty,
        ValueTypes.reconciledUncertainty,
        ValueTypes.reconciledToreconcilevalue,
        ValueTypes.reconciledConstraint,
        ValueTypes.reconciledTarget,
        ValueTypes.sourceValue,
        ValueTypes.targetValue,
        ValueTypes.deviation,
        ValueTypes.relativeDeviation,
        ValueTypes.raw,
        ValueTypes.comment
    ];

    public static allValueTypesExceptRaw: KeyValuePair<string, string>[] = ValueTypes.allValueTypes
        .filter(vt => vt.key !== ValueTypes.raw.key);

    public static ruleValueType: KeyValuePair<string, string>[] = [
        ValueTypes.average,
        ValueTypes.standardDeviation,
        ValueTypes.gradient,
    ];

    public static ValueTypesSupportedByDigitalDataType: string[] = [
        ValueTypes.average.key.toLowerCase(),
        ValueTypes.interpolated.key.toLowerCase(),
        ValueTypes.minimum.key.toLowerCase(),
        ValueTypes.maximum.key.toLowerCase(),
        ValueTypes.raw.key.toLowerCase(),
        ValueTypes.reconciledValue.key.toLowerCase(),
        ValueTypes.value.key.toLowerCase(),
        ValueTypes.validatedvalue.key.toLowerCase(),
        ValueTypes.manualvalue.key.toLowerCase(),
        ValueTypes.sourceValue.key.toLowerCase(),
        ValueTypes.targetValue.key.toLowerCase(),
        ValueTypes.reconciledToreconcilevalue.key.toLowerCase(),
        ValueTypes.reconciledTarget.key.toLowerCase()
    ];

    public static ValueTypesSupportedByStringDataType: string[] = [
        ValueTypes.average.key.toLowerCase(),
        ValueTypes.interpolated.key.toLowerCase(),
        ValueTypes.minimum.key.toLowerCase(),
        ValueTypes.maximum.key.toLowerCase(),
        ValueTypes.raw.key.toLowerCase(),
        ValueTypes.reconciledValue.key.toLowerCase(),
        ValueTypes.value.key.toLowerCase(),
        ValueTypes.validatedvalue.key.toLowerCase(),
        ValueTypes.manualvalue.key.toLowerCase(),
        ValueTypes.sourceValue.key.toLowerCase(),
        ValueTypes.targetValue.key.toLowerCase(),
        ValueTypes.reconciledToreconcilevalue.key.toLowerCase(),
        ValueTypes.reconciledTarget.key.toLowerCase()
    ];

    static getValueType(key: string): string {
        const found = ValueTypes.allValueTypes.find(v => v.key === key);
        return found ? found.value : null;
    }
}